import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const AccountExtractionLoaderPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "AccountExtractionLoaderPopup" */ './View'),
  'popup'
);
